import { render } from "./ClosedTickets.vue?vue&type=template&id=c8b8b856"
import script from "./ClosedTickets.vue?vue&type=script&lang=js"
export * from "./ClosedTickets.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__